<div class="wrapper p-2">
    <!-- header -->
    <div class="info-header">
        <div class="first">
            <i class="fas fa-file-alt mr-1"></i>
            <span class="info-font">Extensões permitidas: PDF</span>
        </div>
        <div class="second">
            <i class="fas fa-copy mr-1"></i>
            <span class="info-font">Quantidade máxima: 1 arquivo</span>
        </div>
    </div>

    <!-- body -->
    <div class="file-container p-2" [class.disabled]="$disabled()">
        <!-- botão default -->
        <span class="main-button" [class.v-hidden]="$activeButton() != 'main'">
            <label class="m-0 py-1 px-2" [class.has-value]="$fileName() != null">
                <i class="fas mr-1" [ngClass]="$fileName()!= null ? 'fa-edit' : 'fa-folder-open'"></i>
                <span>{{($fileName() != null ? 'Alterar' : 'Selecionar')}} arquivo</span>

                @if ($render()) {
                    <input type="file" accept="application/pdf" [disabled]="$disabled()" (change)="changeFile($event)" #fileRef>
                }
            </label>
        </span>

        @switch ($activeButton()) {
            @case ('prevent') {
                <!-- botão de cancelamento de upload -->
                <span class="prevent-upload state-button" (click)="preventUpload()" (keyDown)="preventUpload()">
                    <span class="countdown">
                        <svg><circle r="12" cx="20" cy="20"></circle></svg>
                    </span>
                    <i class="fas fa-stopwatch mr-2"></i>
                    <span>Cancelar upload?</span>
                </span>
            }
            @case ('cancelled') {
                <!-- botão de upload cancelado -->
                <span class="upload-cancelled state-button">
                    <i class="fas fa-times-circle mr-1"></i>
                    <span>Upload cancelado!</span>
                </span>
            }
            @case ('progress') {
                <!-- botão de upload em andamento -->
                <span class="upload-progress state-button">
                    @switch ($progressState()) {
                        @case ('start') {
                            <i class="fas fa-hourglass-start mr-2"></i>
                        }
                        @case ('half') {
                            <i class="fas fa-hourglass-half mr-2"></i>
                        }
                        @case ('end') {
                            <i class="fas fa-hourglass-end mr-2"></i>
                        }
                    }

                    <span>Realizando upload...</span>
                </span>
            }
            @case ('done') {
                <!-- botão de upload concluído -->
                <span class="upload-complete state-button">
                    <i class="fas fa-check-circle mr-2"></i>
                    <span>Upload concluído!</span>
                </span>
            }
        }

        <!-- container do nome do arquivo -->
        <span class="file-name-container">
            @if ($fileName() != null) {
                <!-- Nome -->
                <span class="info-font">
                    {{$fileName()}}
                </span>

                <span class="actions-container">
                    @if (!$disabled()) {
                        <!-- Remover arquivo -->
                        <button class="btn btn-outline-danger action"
                                (click)="confirmRemoveFile($event)"
                                (keyDown)="confirmRemoveFile($event)"
                        >
                            <i class="remove-file fas fa-times-circle" matTooltip="Remover arquivo"></i>
                            <span>Remover</span>
                        </button>
                    }

                    @if ($fileName() != null && !$disabled()) {
                        <!-- Visualizar arquivo -->
                        <button class="btn btn-outline-primary action"
                                (click)="viewFile()"
                                (keyDown)="viewFile()"
                        >
                            <i class="view-file fas fa-eye" matTooltip="Visualizar arquivo"></i>
                            <span>Visualizar</span>
                        </button>
                    }
                </span>
            } @else {
                <span class="info-font font-italic">Nenhum arquivo selecionado</span>
            }
        </span>
    </div>
</div>
